const EditListingPageStyles = {
  container: {
    padding: '2rem',
    maxWidth: '600px',
    margin: '2rem auto', // Add vertical margin to separate it from other elements
    backgroundColor: '#f4f4f9',
    borderRadius: '10px',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    display: 'flex', // Ensures proper alignment
    flexDirection: 'column', // Stacks child elements vertically
    alignItems: 'center', // Centers children horizontally
  },
  paper: {
    width: '100%', // Ensure the paper takes the full width of the container
    padding: '2rem',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem', // Add consistent spacing between children
  },
  title: {
    fontWeight: 'bold',
    marginBottom: '1.5rem',
    textAlign: 'center',
    fontSize: '1.5rem', // Ensure the title is prominent
  },
  textField: {
    marginBottom: '1rem',
    width: '100%', // Ensure fields take full width
  },
  submitButton: {
    marginTop: '1rem',
    padding: '0.75rem',
    fontWeight: 'bold',
    width: '100%', // Ensure the button aligns with the form width
    backgroundColor: '#81c241', // Example primary color
    color: '#fff', // Text color for contrast
    borderRadius: '5px', // Make the button consistent with the design
    textAlign: 'center', // Align button text
  },
};

export default EditListingPageStyles;
